export default "__VITE_ASSET__jQ8kVeIE__"